import React from "react";
import Profile from "../components/Profile";
import Layout from "./Layout";

export default function ProfileView() {
  return (
    <Layout title="Profiel">
      <Profile />
    </Layout>
  );
}
